import { MAX_TARGET_SECONDS } from "../workoutBuilder/repPrescription";

// TIMED_HOLD-only prescription control. Draft ownership and commit timing stay
// in the builder container; this component only presents the seconds field.
export default function HoldSecondsControl({
  prescription,
  drafts,
  disabled = false,
  label,
  onFieldFocus,
  onFieldChange,
  onFieldBlur,
}) {
  const persistedValue = prescription?.targetSeconds;
  const value = drafts?.targetSeconds ??
    (persistedValue == null ? "" : String(persistedValue));

  return (
    <div className="lz-builder-rep-control lz-builder-hold-control">
      <div className="lz-builder-rep-control__values">
        <input
          type="number"
          inputMode="numeric"
          disabled={disabled}
          min="1"
          max={String(MAX_TARGET_SECONDS)}
          step="1"
          value={value}
          aria-label={`${label} seconds`}
          onFocus={() => onFieldFocus("targetSeconds")}
          onChange={(event) => onFieldChange("targetSeconds", event.target.value)}
          onBlur={() => onFieldBlur("targetSeconds")}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              event.currentTarget.blur();
            }
          }}
          className="lz-builder-rep-field"
        />
        <span className="lz-builder-rep-control__unit" aria-hidden="true">s</span>
      </div>

      {prescription?.legacyReps ? (
        <span className="lz-builder-rep-control__legacy">
          Legacy: {prescription.legacyReps}
        </span>
      ) : null}
    </div>
  );
}
